import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  CartItem,
  Finish, IExtrusion,
  IFilterItemRequest, IFinish,
  IItemList, IQuickAddLabel, ItemList, ItemSuggestion, MasterData
} from 'src/app/core/models';
import { ItemService } from 'src/app/core/services/item.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { UserService } from '../../../core/services/user.service';
import { CartService } from '../../../core/services/cart.service';
import { QuoteService } from '../../../core/services/quote.service';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { NotifyType } from '../../../core/enums/NotifyType';
import { Router } from '@angular/router';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { environment } from 'src/environments/environment';
import { V6productService } from '../../../core/services/v6product.service';
@Component({
  selector: 'app-quick-add-item',
  templateUrl: './quick-add-item.component.html',
  styleUrls: ['./quick-add-item.component.scss']
})
export class QuickAddItemComponent implements OnInit {
  quickAddLblTxt: IQuickAddLabel;
  @Input() mode: string;
  @Input() quoteCommonId: string;
  @Output() itemAdded = new EventEmitter<any>();
  @ViewChild('searchItem', { static: false }) itemSearch;
  @ViewChild('finish', { static: false }) finish;

  constructor(
    private ref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private masterService: MasterDataService,
    private appNotifyService: AppNotifyService,
    private userService: UserService,
    private itemService: ItemService,
    private cartService: CartService,
    private quoteService: QuoteService,
    private router: Router, private languageTranslationService: LanguageTranslationService, private cartservice: CartService,
    private v6productService: V6productService) {

  }
  //#region init area
  quickAddSubmitBtnText: string = '';
  public paints: MasterData[] = [];
  public isEmptyPaint: boolean;
  public isEmptyFinish: boolean;
  public closeDefaultMessage: string;
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.paints = this.masterService.getPaintValues();
    this.initForm();
    if (this.mode === 'add-to-cart') {
      this.quickAddSubmitBtnText = this.quickAddLblTxt.submitBtnLbl1 ? this.quickAddLblTxt.submitBtnLbl1 : this.quickAdd.submitBtnLbl1;
    } else if (this.mode === 'add-to-quote') {
      this.quickAddSubmitBtnText = this.quickAddLblTxt.submitBtnLbl2 ? this.quickAddLblTxt.submitBtnLbl2 : this.quickAdd.submitBtnLbl2;
    }
    this.defaultMessage = this.quickAddLblTxt.defaultInfoLbl1 ? this.quickAddLblTxt.defaultInfoLbl1 : this.quickAdd.defaultInfoLbl1;
    this.closeDefaultMessage = this.quickAddLblTxt.defaultInfoLbl2 ? this.quickAddLblTxt.defaultInfoLbl2 : this.quickAdd.defaultInfoLbl2;
  }
  ngAfterViewInit() {
    this.itemSearch.focus();
  }
  initForm() {
    this.availableFinishes = [];
    this.availablePaints = [];
    this.availableSizes = [];
    this.selectedPaint = '';
    this.selectedSize = '';
    this.selectedFinishValue = '';
    this.selectedQuantity = 1;
    this.selectedItemNumber = '';
    this.unitOfMeasure = "EA";
    this.selectedItem = new ItemList();
    this.selectedItemSuggestion = new ItemSuggestion();
    this.showPaint = false;
  }
  //#endregion
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [

      { controlName: "idDescriptionLbl" },
      { controlName: "finishLbl" },
      { controlName: "setDefaultLbl" },
      { controlName: "defaultLbl" },
      { controlName: "paintLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "paintLbl" },
      { controlName: "quantityLbl" },
      { controlName: "uomLbl" },
      { controlName: "addToCartLbl" },
      { controlName: "clearSelection" },
      { controlName: "buildBuyLbl" },
      { controlName: "defaultInfoLbl1" },
      { controlName: "defaultInfoLbl2" },
      { controlName: "submitBtnLbl1" },
      { controlName: "submitBtnLbl2" },

    ];
    const componentName = "quickadd";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.quickAddLblTxt = response[response.length - 1];
      console.log(response);
    }
  }


  //#endregion

  //#region label declaration
  public quickAdd = {
    idDescriptionLbl: 'Item ID or Description',
    finishLbl: 'Finish',
    setDefaultLbl: 'Set default',
    defaultLbl: 'default',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',
    uomLbl: 'UoM',
    addToCartLbl: 'Add Item To Cart',
    clearSelectionLbl: 'Clear Selection',
    buildBuyLbl: 'Build & Buy',
    defaultInfoLbl1: "Select \u201CSet Default\u201D to apply this finish automatically as parts are entered during Quick Add",
    defaultInfoLbl2: "Select the \u201CX\u201D  to remove default selection",
    submitBtnLbl1: "Add Item to Cart",
    submitBtnLbl2: "Add Item to Quote",
  }
  //#endregion

  public itemsLoading = false;
  public filteredSuggestions: ItemSuggestion[] = [];

  selectedItemDescription: any;
  selectedItemNumber: string;
  selectedItemSuggestion: ItemSuggestion = new ItemSuggestion();

  availableFinishes: IFinish[] = [];
  selectedFinishValue: string;
  availableSizes: IExtrusion[];
  selectedSize: string;
  availablePaints: MasterData[];
  selectedPaint: string;
  selectedQuantity: number;
  unitOfMeasure: string;


  ctrlQuickAddFinish: FormControl;
  ctrlQuickAddPaint: FormControl;


  selectedItem: IItemList;
  loadingQuickAddFinsh: boolean;

  isSetDefaultOn: boolean = false;
  defaultValue: string = '';


  public defaultFinish: IFinish = null;
  public defaultPaint: any = null;
  public quickAddDefaultFinish: IFinish = null;
  public quickAddDefaultPaint: any = null;
  public isDefaultFinishAvailable: Boolean = false;
  public isDefaultPaintAvailable: Boolean = false;
  requestInProcess: boolean = false;

  public defaultExtrusion: IExtrusion;
  public quickAddDefaultExtrusion: IExtrusion = null;

  public thereAreMultipleExtrusionOptions: Boolean = false;
  public mySelection: any[] = [];

  public showPaint = false;

  //#region item suggestion & get details area
  handleItemFilter(searchQuery: string) {
    if (searchQuery.length > 0) {// configurable item maybe in environment file      
      searchQuery = searchQuery.toUpperCase();
      this.itemsLoading = true;
      this.itemService
        .getItemSuggestions({
          searchstring: searchQuery,
          categoryId: -1,
          customerNumber: this.userService.readUserObject.customerNumber,
          countryCode: this.userService.readUserObject.countryCode,
        })
        .subscribe((resp: ItemSuggestion[]) => {
          this.filteredSuggestions = resp;
          this.itemsLoading = false;
        });
    }
  }
  public defaultMessage: string;
  public showDefaultInfo: boolean;
  defaultInfoToggle() {
    this.showDefaultInfo = !this.showDefaultInfo;
  }
  itemSelected(itemFullDescription) {
    if (!itemFullDescription) {
      this.initForm();
      return;
    }
    this.selectedItemSuggestion = this.filteredSuggestions.find((r) =>
      r.fullDescription.toUpperCase().startsWith(itemFullDescription.toUpperCase())
    );
    if (!this.selectedItemSuggestion) {
      this.initForm();
      return;
    }
    //if item type 2 then make build & buy button visible
    //if (this.selectedItemSuggestion.itemType === 1) {
    //this.initForm();
    this.loadItemDetails(this.selectedItemSuggestion.itemNumber);
    //}
  }
  loadItemDetails(itemNumber: string) {
    this.loadingQuickAddFinsh = true;
    this.itemsLoading = true;
    //reset form
    const customerNumber = this.userService.readUserObject.customerNumber;
    this.itemService
      .getItemDetails(itemNumber, customerNumber)
      .subscribe((data) => {
        this.selectedItem = data;// put check for length    
        this.initFinish();
        this.initPaint();
        this.initSize();
        this.loadingQuickAddFinsh = false;
        this.itemsLoading = false;
        if (this.availableFinishes.length > 0) {
          this.ref.detectChanges();//to check that finish dropdown is visible and set the focus.
          this.finish.focus();
        }
        //this.quickAddSetDefaultValue();
      });
  }

  //#endregion
  //#region init finish,paint,size dropdown
  initFinish() {
    this.isEmptyFinish = false;
    this.availableFinishes = this.selectedItem.availableFinish;
    this.checkIfFinishSetToDefault();
    if (this.availableFinishes.length === 1) {
      this.selectedFinishValue = this.availableFinishes[0].value;
    }
  }
  initPaint() {
    this.isEmptyPaint = false;
    if (this.selectedFinishValue && this.selectedFinishValue === '22') {
      this.availablePaints = this.paints;
      this.showPaint = true;
      this.checkIfPaintSetToDefault();
    }
    else {
      this.availablePaints = [];
      this.selectedPaint = '';
    }
  }
  initSize() {
    if (this.selectedFinishValue) {
      const selFin = this.availableFinishes.find(x => x.value === this.selectedFinishValue);
      if (selFin.availableSizes && selFin.availableSizes.length > 0 && selFin.availableSizes[0].value) {
        this.availableSizes = selFin.availableSizes;
        this.selectedSize = selFin.availableSizes[0].value;
        return;
      }
    }
    this.availableSizes = [];
    this.selectedSize = '';
  }
  //#endregion
  //#region set default area
  public checkIfFinishSetToDefault() {
    if (!this.defaultFinish || !this.defaultFinish.value) return;
    const defaultFin = this.availableFinishes.find(x => x.value === this.defaultFinish.value);
    if (defaultFin) {
      this.selectedFinishValue = this.defaultFinish.value;
    }
    else {
      this.selectedFinishValue = '';
    }
  }
  public checkIfPaintSetToDefault() {
    if (this.defaultPaint) {
      this.selectedPaint = this.defaultPaint.value;
      this.isDefaultPaintAvailable = true;
    }
    else {
      this.isDefaultPaintAvailable = false;
      this.selectedPaint = '';//this.availablePaints[0].value; //fix for K50-452
    }
  }
  //#endregion
  //#region finish,paint,size change handlers
  finishSelected(fin) {
    if (fin) {
      const f = this.availableFinishes.find(x => x.value === fin);
      this.selectedFinishValue = f.value;
      if (this.selectedFinishValue == '22') {
        this.showPaint = true;
      }
      else {
        this.showPaint = false;
      }
      this.initPaint();
      this.initSize();
    }
    else {
      this.selectedFinishValue = '';
    }
  }
  paintSelected(paint) {
    if (paint) {
      const p = this.availablePaints.find(x => x.value === paint);
      this.selectedPaint = p.value;
    }
    else {
      this.selectedPaint = '';
    }
  }
  sizeSelected(size) {
    if (size) {
      this.selectedSize = size;
    } else {
      this.selectedSize = '';
    }
  }
  //#endregion
  //public isInvalidFinishValue = false;
  //public isInvalidPaintValue = false;
  //public isInvalidItemSuggestion = false;
  //validateQuickAddSubmit() {
  //  var validate = true;
  //  if (!this.selectedItemSuggestion) {
  //    this.isInvalidItemSuggestion = true;
  //    validate = false;
  //  }
  //  else if (!this.selectedFinishValue) {
  //    this.isInvalidFinishValue = true;
  //    validate = false;
  //  }
  //  else if (this.selectedFinishValue == '22' && !this.selectedPaint) {
  //    this.isInvalidPaintValue = true;
  //    validate = false;
  //  }
  //  return validate;
  //}
  validateFinish() {
    this.isEmptyFinish = false;
    if (this.availableFinishes && this.availableFinishes.length > 0) {
      if (!this.selectedFinishValue || this.selectedFinishValue.length == 0) {
        this.isEmptyFinish = true;
      }
    }
  }
  validatePaint() {
    this.isEmptyPaint = false;
    if (this.selectedFinishValue == '22') {
      if (!this.selectedPaint || this.selectedPaint.length == 0) {
        this.isEmptyPaint = true;
      }
    }
  }


  onQuickAddSubmit(): void {
    //  if (!this.validateQuickAddSubmit()) {
    //    return;
    //}
    this.validateFinish();
    this.validatePaint();
    if (this.isEmptyFinish || this.isEmptyPaint) {
      return;
    }
    //if (!this.selectedItemSuggestion || this.selectedItemSuggestion.itemNumber === "") {
    //  return;
    //}

    const data: any = {};

    data.itemNumber = this.selectedItemSuggestion.itemNumber;
    data.size = this.selectedSize;
    data.finishValue = this.selectedFinishValue;
    var tempFinish = this.availableFinishes.find(r => r.value == this.selectedFinishValue);
    data.finish = tempFinish ? tempFinish.name : data.finish;
    data.paint = this.selectedPaint;
    data.quantity = this.selectedQuantity;
    const tempPaint = this.paints.find(r => r.value === data.paint);
    data.paintName = tempPaint ? tempPaint.name : '';
    data.customerNumber = this.userService.readUserObject.customerNumber;
    //data.userId = this.userService.readUserObject.userId;//temporary

    //long item number--> longitemnumber=itemnumber, if finish not null=={longitemnumber+=finishvale, if size not null longitemnumber+=size}
    var longItemNumber = data.itemNumber;
    longItemNumber = (data.finishValue && data.finishValue.length > 0) ? longItemNumber + '-' + data.finishValue : longItemNumber;
    longItemNumber = (data.size && data.size.length > 0) ? longItemNumber + '-' + data.size : longItemNumber;
    data.longItemNumber = longItemNumber;
    data.OrderSource = 1;
    if (this.mode === 'add-to-cart') {
      //checks count of items in the cart 
      const cartGridItemCount = this.cartservice.totalCartItem.value;
      const maxCount = environment.maxCartQuoteItemCount;
      if (cartGridItemCount >= maxCount) {
        this.appNotifyService.notify(NotifyType.INFO, "Maximum 99 items allowed in the cart");
        return;
      }
      this.requestInProcess = true;
      this.cartService.addStockItem(data).subscribe(
        (cartResponse: any) => {
          this.initForm();
          this.itemSearch.focus();
          this.requestInProcess = false;
          if (cartResponse) {
            this.itemAdded.emit(cartResponse);
            this.appNotifyService.notify(NotifyType.SUCCESS, "Successfully Added to Cart");
          }
          else {
            this.appNotifyService.notify(NotifyType.ERROR, "Error occured while adding item to cart");
          }
        },
        (error) => {
          this.requestInProcess = false;
          this.appNotifyService.notify(NotifyType.ERROR, "Error occured while adding item to cart");
        }
      );
    }

    else if (this.mode === 'add-to-quote') {
      const quoteGridData = this.quoteService.kdQuoteItems;
      const maxCount = environment.maxCartQuoteItemCount;
      if (quoteGridData.length >= maxCount) {
        this.appNotifyService.notify(NotifyType.INFO, "Maximum 99 items allowed in the quote");
        return;
      }
      
      data.quoteCommonId = this.quoteCommonId;
      this.requestInProcess = true;
      //we'll require quoteCommonId to addItemToQuote
      this.quoteService.addItemToKdQuote(data).subscribe(
        (quoteResponse: any) => {
          this.initForm();
          this.itemSearch.focus();
          this.requestInProcess = false;
          if (quoteResponse) {
            this.itemAdded.emit(quoteResponse);
            this.appNotifyService.notify(NotifyType.SUCCESS, "Successfully Added to Quote");
          }
          else {
            this.appNotifyService.notify(NotifyType.ERROR, "Error occured while adding item to Quote");
          }
        },
        error => {
          //reset selections
          this.initForm();
          this.itemSearch.focus();
          this.requestInProcess = false;
          this.appNotifyService.notify(NotifyType.ERROR, "Error occured while adding item to Quote");
        }
      );
    }

    //depending on the mode
    //prepare object
    //itemnumber,finish(value, description, v6code),size,paint(name, value)
    //qty, long item number--> longitemnumber=itemnumber, if finish not null=={longitemnumber+=finishvale, if size not null longitemnumber+=size}
    //userid, customer number--either call add to cart or add to quote
    //call api
    //get response object, pass the object to the parent//resekt form
    // map data for transport
    // should show a loading indicator somewhere
    //console.log(this.selectedItemSuggestion);
    //if (this.selectedQuickAddItem.itemType === 2) {
    //  this.appNotify.notify(NotifyType.SUCCESS, 'Coming soon!!!!!');
    //  return;
    //}


    // notify navbar component to update the cart item count.
  }

  configureItem(item: any) {
    //validation
    this.validateFinish();
    this.validatePaint();
    if (this.isEmptyFinish || this.isEmptyPaint) {
      return;
    }

    //Actual Code
    let productCode: string = '';
    if (this.selectedFinishValue) {
      productCode = `${item.itemNumber}-${this.selectedFinishValue}`;
    } else {
      productCode = item.itemNumber;
    }
    if (this.selectedPaint) {
      this.v6productService.v6ProductPreview.paintCode = this.selectedPaint;
      var tempPaint = this.paints.find(r => r.value === this.selectedPaint)
      this.v6productService.v6ProductPreview.paintName = tempPaint.name;
    }
    else {
      //no paint applicable so clear out the paint fields
      this.v6productService.v6ProductPreview.paintCode = "";
      this.v6productService.v6ProductPreview.paintName = "";
    }

    if (this.mode === 'add-to-cart' && this.quoteService && this.quoteService.selectedQuoteHeader && this.quoteService.selectedQuoteHeader.quoteCommonId) {
      this.quoteService.selectedQuoteHeader.quoteCommonId = null; //should not select quote in the Add to Quote popup from here
    }
    const routepath = `/build-and-buy/buildKwikkeyProduct/${productCode}`;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });

  }
  onQuickAddReset(): void {
    this.initForm();
    this.itemSearch.focus();
    this.requestInProcess = false;
  }
  //public quickAddSetDefaultValue() {
  //  if (this.availableFinishes) {
  //    // if Finish is only one Finish
  //    if (this.availableFinishes.length === 1) {
  //      this.selectedFinishValue = this.availableFinishes[0].value;

  //    } else if (this.availableFinishes.length > 1) {  // if Finish is more than one item then Default matching
  //      if (this.defaultFinish) {
  //        const tempfinish = this.availableFinishes.find(r => r.value == this.defaultFinish.value);
  //        if (this.defaultPaint) {
  //          this.selectedPaint =  this.defaultPaint.value;
  //        }
  //        else {
  //          this.selectedPaint = '';
  //        }
  //        if (tempfinish) {
  //          this.selectedFinishValue = tempfinish.value;
  //        }
  //      } else {
  //        this.selectedFinishValue = '';
  //        this.selectedPaint = '';
  //      }
  //    } else {
  //      this.availableFinishes = [];
  //      //this.availableFinishes.push(
  //      //  {
  //      //    value: null, name: '', availableSizes: [{ value: null, basePrice: 0, listPrice: 0 }], eurrentExtrusionLength: null, basePrice: 0, listPrice: 0
  //      //  });
  //      this.selectedFinishValue = '';//this.availableFinishes[0].value;
  //    }
  //  }
  //}
  public setDefaultFinish(): void {
    this.defaultFinish = this.selectedItem.availableFinish.find(r => r.value === this.selectedFinishValue);
    if (this.defaultFinish.value == '22' && this.selectedPaint.length > 0) {
      this.defaultPaint = this.paints.find(r => r.value === this.selectedPaint)
      this.isDefaultPaintAvailable = true;
      this.defaultValue = this.defaultPaint.name;
    }
    else {
      this.isDefaultPaintAvailable = false;
      this.isDefaultFinishAvailable = true;
      this.defaultValue = this.defaultFinish.name;
    }
    //if (this.selectedItem) {
    //  if (this.selectedItem.availableFinish) {

    //    this.defaultFinish = this.finishChosen(this.selectedFinishValue);
    //    if (this.defaultFinish) {

    //      if (this.defaultFinish.value) {
    //        this.defaultValue = this.defaultFinish.name;
    //        if (this.defaultFinish.value == '22') {
    //          this.defaultPaint = this.paintChosen(this.selectedPaint);
    //          if (this.defaultPaint) {
    //            this.isDefaultPaintAvailable = true;
    //            this.defaultValue = this.defaultPaint.name;
    //          }
    //          else {
    //            this.isDefaultPaintAvailable = false;                
    //          }
    //        }
    //        this.isDefaultFinishAvailable = true;
    //      } else {
    //        this.isDefaultFinishAvailable = false;
    //      }
    //    } else {
    //      this.isDefaultFinishAvailable = false;
    //      this.isDefaultPaintAvailable = false;

    //    }
    //  }

    //}

  }
  public reSetDefaultFinish(): void {
    this.defaultFinish = null;
    this.defaultPaint = null;
    this.isDefaultFinishAvailable = false;
    this.isDefaultPaintAvailable = false;
    if (!this.itemSearch.value) {
      this.availableFinishes = [];
      this.availableFinishes.push(
        {
          value: null, name: null, availableSizes: [{ value: null, basePrice: 0, listPrice: 0 }], eurrentExtrusionLength: null, basePrice: 0, listPrice: 0
        });
      this.initForm();

    }
  }
  //public finishChosen(finishId: string): IFinish {
  //  if (this.selectedItem) {
  //    if (this.selectedItem.availableFinish) {
  //      const tempfinish = this.selectedItem.availableFinish.find(r => r.value === finishId);
  //      if (tempfinish) {
  //        return tempfinish;
  //      }
  //    }
  //  }
  //  return null;
  //}
  //public paintChosen(paintValue: string): any {
  //  if (this.selectedItem) {
  //    //if (this.quickAddSelectedItem.paints) {
  //    const tempPaint = this.paints.find(r => r.value === paintValue);
  //    if (tempPaint) {
  //      return tempPaint;
  //    }
  //    // }
  //  }
  //  return null;
  //}

  public handlePaintFilter(event) {
    this.availablePaints = this.paints.filter(
      (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }


}
